// src/services/otpService.js
import emailjs from "@emailjs/browser";
import { doc, setDoc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";
import { generateOTP, hashOTP } from "../utils/otp";
import { verifyAdminEmail } from "../utils/adminCheck";

export const sendOTP = async (email) => {
    try {
        await verifyAdminEmail(email);

        const otp = generateOTP();
        const otpHash = await hashOTP(otp);

        await setDoc(doc(db, "passwordResets", email), {
            otpHash,
            expiresAt: Date.now() + 5 * 60 * 1000,
            verified: false,
        });

        await emailjs.send(
            process.env.REACT_APP_EMAILJS_SERVICE_ID,
            process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
            { otp, email },
            process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        );


    } catch (err) {
        console.error("sendOTP failed:", err);
        throw new Error(err?.message || "Failed to send reset code");
    }
};


export const verifyOTP = async (email, otp) => {
    const ref = doc(db, "passwordResets", email);
    const snap = await getDoc(ref);

    if (!snap.exists()) throw new Error("OTP expired");
    if (Date.now() > snap.data().expiresAt) throw new Error("OTP expired");

    const hashed = await hashOTP(otp);
    if (hashed !== snap.data().otpHash)
        throw new Error("Invalid OTP");

    await updateDoc(ref, { verified: true });
};
